import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getManufacturerList = async () => {
  const { data } = await api.get(endpoints.dashboard.manufacturerList);

  return data;
};

/**
 * fetch manufacturers from 'manufacturers' collection
 * returns with manufacturer id and other details
 */
export const fetchManufacturers = async () => {
  const { data } = await api.get(endpoints.manufacturer.fetchManufacturers);
  return data;
};
